var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoBinoculars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99625 5.00313C1.91688 7.93438 0.109375 8.57188 0 12.625V14C0 14.55 0.45 15 1 15H5C5.55 15 6 14.55 6 14V9H7V4H2.99625C2.44562 4 2.01094 4.45313 1.99625 5.00313ZM14.0031 5.00313C13.9875 4.45313 13.5531 4 13.0031 4H9V9H10V14C10 14.55 10.45 15 11 15H15C15.55 15 16 14.55 16 14V12.625C15.8906 8.57188 14.0844 7.93438 14.0031 5.00313Z",
    fill: "#304A5C",
    className: "fill-primary"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.5003 1H10.5003C10.2221 1 10.0003 1.22281 10.0003 1.5V3H13.0015L13.0003 1.5C13.0003 1.22281 12.7784 1 12.5003 1ZM7.00027 9H9.00027V4H7.00027V9ZM5.50027 1H3.50027C3.22215 1 3.00027 1.22281 3.00027 1.5L2.99902 3H6.00027V1.5C6.00027 1.22281 5.7784 1 5.50027 1Z",
    fill: "#304A5C",
    className: "fill-secondary"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBinoculars);
export default __webpack_public_path__ + "static/media/ico-binoculars.08299c6020e453007cde8d9b87d9ff1e.svg";
export { ForwardRef as ReactComponent };